var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 3.99992C6.06971 3.99992 6.66667 3.40296 6.66667 2.66659C6.66667 1.93021 6.06971 1.33325 5.33333 1.33325C4.59695 1.33325 4 1.93021 4 2.66659C4 3.40296 4.59695 3.99992 5.33333 3.99992ZM10.6667 3.99992C11.403 3.99992 12 3.40296 12 2.66659C12 1.93021 11.403 1.33325 10.6667 1.33325C9.93029 1.33325 9.33333 1.93021 9.33333 2.66659C9.33333 3.40296 9.93029 3.99992 10.6667 3.99992ZM6.66667 7.99992C6.66667 8.7363 6.06971 9.33325 5.33333 9.33325C4.59695 9.33325 4 8.7363 4 7.99992C4 7.26354 4.59695 6.66658 5.33333 6.66658C6.06971 6.66658 6.66667 7.26354 6.66667 7.99992ZM10.6667 9.33325C11.403 9.33325 12 8.7363 12 7.99992C12 7.26354 11.403 6.66658 10.6667 6.66658C9.93029 6.66658 9.33333 7.26354 9.33333 7.99992C9.33333 8.7363 9.93029 9.33325 10.6667 9.33325ZM6.66667 13.3333C6.66667 14.0696 6.06971 14.6666 5.33333 14.6666C4.59695 14.6666 4 14.0696 4 13.3333C4 12.5969 4.59695 11.9999 5.33333 11.9999C6.06971 11.9999 6.66667 12.5969 6.66667 13.3333ZM10.6667 14.6666C11.403 14.6666 12 14.0696 12 13.3333C12 12.5969 11.403 11.9999 10.6667 11.9999C9.93029 11.9999 9.33333 12.5969 9.33333 13.3333C9.33333 14.0696 9.93029 14.6666 10.6667 14.6666Z",
    fill: "#191818",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveHandle);
export default __webpack_public_path__ + "static/media/move-handle.fc46af55327f59dd077e0f7e13b49dd6.svg";
export { ForwardRef as ReactComponent };